import {
  CONGENERS,
  PDF_SECTION_NAMES,
  PRODUCTS_GROUPING,
} from '../utils/constants';

function findTermBySection(terms, sectionName, documentType) {
  const term = terms.find(
    (x) => x.tipoContrato === `${sectionName} ${documentType}`,
  );
  return term ? term.modeloContrato : '';
}

export function getCustomSectionMsgs(terms, documentType) {
  const customSectionsMsgs = {};
  Object.keys(PDF_SECTION_NAMES).forEach((key) => {
    customSectionsMsgs[key] = findTermBySection(
      terms,
      PDF_SECTION_NAMES[key],
      documentType,
    );
  });
  return customSectionsMsgs;
}

export function getComprehensiveFranchise(selectedCoverage) {
  const comprehensiveProduct = selectedCoverage.find(
    (coverage) => coverage.grouping === PRODUCTS_GROUPING.COMPREHENSIVE,
  );
  return comprehensiveProduct.values.franchise;
}

export function getFormattedItemName(item) {
  const isSlider = item.input === 'slider';
  if (isSlider) {
    const formattedValue =
      item.unity === 'mil'
        ? `R$ ${item.quantity / 1000} ${item.unity}`
        : `R$ ${item.quantity} ${item.unity}`;
    const formattedItemName = `${item.productName} - ${formattedValue}`;
    return formattedItemName;
  }
  const isNotContracted = item.optionName.split(' ')[0].toLowerCase() === 'sem';
  const formattedItemName = isNotContracted
    ? item.optionName
    : `${item.productName} - ${item.optionName}`;
  return formattedItemName;
}

export function getFormattedItemLmi(item) {
  const formattedValue =
    item.unity === 'mil'
      ? `R$ ${item.quantity / 1000} ${item.unity}`
      : `R$ ${item.quantity} ${item.unity}`;
  switch (item.grouping) {
    case PRODUCTS_GROUPING.APP:
      return (
        formattedValue +
        (item.productName.includes('APP') ? '/passageiro' : '/diária')
      );
    case PRODUCTS_GROUPING.COMPREHENSIVE:
      return '100% da Fipe';
    default: {
      const isNotContracted =
        item.optionName.split(' ')[0].toLowerCase() === 'sem';
      if (isNotContracted) return 'Não contratada';
      return formattedValue;
    }
  }
}

function isGlass(text) {
  return text.toLowerCase().includes('vidro');
}

export function getSelectedGlassServices(coverageContracted, coverageDetails) {
  return coverageContracted
    .map((contract) => {
      return coverageDetails
        .filter(
          (detail) => detail.isService === true && isGlass(detail.productName),
        )
        .find((detail) => detail.id === contract.id);
    })
    .filter((detail) => detail !== undefined && detail !== null);
}

export function somaValorTotalValoresAvista(arr1) {
  var total = 0;
  if (arr1 && arr1.length > 0)
    arr1.forEach((element) => {
      if (element.isMensal != true) total = total + element.valorFinal;
    });
  return total;
}

export function getInsuranceCompanyLabel(id, insuranceCompanies) {
  const seguradora = insuranceCompanies.find(
    (seguradora) => seguradora.id === id,
  );
  if (seguradora) {
    return seguradora.label;
  }
  return id === CONGENERS.NOT_RENEWAL.id
    ? CONGENERS.NOT_RENEWAL.label
    : CONGENERS.OTHER.label;
}

export function hasInsuranceCompany(id, insuranceCompanies) {
  const seguradora = insuranceCompanies.find(
    (seguradora) => seguradora.id === id,
  );
  return (
    seguradora &&
    seguradora.label !== CONGENERS.OTHER.label &&
    seguradora.label !== CONGENERS.NOT_RENEWAL.label
  );
}

export function getAllFranchises(glassServices) {
  if (!glassServices || !glassServices.length) {
    return [];
  }

  const deductibles = glassServices[0].values.deductibles;

  if (!Array.isArray(deductibles)) {
    let allFranchises = [];

    glassServices.forEach((service) => {
      if (service && service.values.othersFranchises) {
        const franchisesArray = Object.keys(
          service.values.othersFranchises,
        ).map((key) => {
          return {
            name: key,
            value: service.values.othersFranchises[key],
          };
        });
        allFranchises = allFranchises.concat(franchisesArray);
      }
    });

    return allFranchises;
  }

  const franchises = [];

  deductibles.forEach((d) => {
    d.deductibles.forEach((de) => {
      franchises.push({ name: de.description, value: de.value });
    });
  });

  return franchises;
}
